export const THDFormControlStyles = {};
